import "../css/styles.css";
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";
import * as Turbo from '@hotwired/turbo'
import { getAnalyticsProps, debounce } from './analytics'

window.Stimulus = Application.start()
const context = require.context('./controllers', true, /\.js$/)
Stimulus.load(definitionsFromContext(context))
window.Turbo = Turbo

// We need to call ethicalads.load_placements for each navigation
// which will trigger a turbo:render event. turbo:render won't be called
// on the initial page load as opposed to turbo:load
// Handle EthicalAds placement loading
const loadEthicalAds = async () => {
  try {
    console.debug('Loading EthicalAds placements')
    await ethicalads.load_placements(true)
    console.debug('EthicalAds placements loaded successfully')
  } catch (error) {
    console.error('Failed to load EthicalAds placements:', error)
  }
}

// Debounce analytics call to prevent too many rapid calls during quick navigation
const debouncedAnalytics = debounce(() => {
  try {
    const props = getAnalyticsProps()
    plausible('pageview', { props })
    console.debug('Analytics event sent successfully')
  } catch (error) {
    console.error('Failed to send analytics:', error)
  }
}, 250) // Wait 250ms between calls

// Load ads on each page render
document.documentElement.addEventListener('turbo:render', () => {
  loadEthicalAds()
})

// Track analytics on page navigation
document.documentElement.addEventListener('turbo:load', () => {
  debouncedAnalytics()
})
